module.exports = __webpack_public_path__ + "static/assets/5b15bdb771489200d14678792d560f4d.png";